import { useContext, useEffect, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useBreakpointValue,
  Text,
  ModalFooter,
  Button,
  Box,
  Divider,
  Center,
  Flex,
  Tooltip,
  Grid,
  Spinner,
} from "@chakra-ui/react";
import HeadingSS from "../Heading/HeadingSS";
import { DDMMYYYY_FORMAT, formatDateTime } from "utils/dateUtils/dateUtils";
import { FaFile } from "react-icons/fa";
import ApprovalHistoryProgress from "./ApprovalHistoryProgress";
import ViewerModal from "../ViewerModal";
import { appRequest } from "routes";
import { AppContext } from "AppProvider/AppContext";
import CommentDrawer from "../CommentDrawer/CommentDrawer";
import UploadDocumentModal from "../UploadDocumentModal/UploadDocumentModal";
import PDFViewer from "../FileViewerModal/pdfViewer";
import FileViewer from "components/common/FileViewerPdfAndImage/FileViewer";
import FileViewerModal from "../ViewerModal/FileViewerModel";

type ModalProps = {
  onClose: () => void;
  isOpen: boolean;
  name: string;
  approvalHistory: any;
  file: any;
  id: any;
  commentModel: {
    selectedStatus: string;
    open: boolean;
    comment: string;
  };
  setCommentModel: React.Dispatch<
    React.SetStateAction<{
      selectedStatus: string;
      open: boolean;
      comment: string;
      isMulti?: boolean;
    }>
  >;
  selectedRows: any[];
  setSelectedRows: React.Dispatch<React.SetStateAction<any[]>>;
  handleGet: () => void;
  docID: any;
  isDuplicate?: any
};

export default function ApprovalHistoryModal({
  isOpen,
  onClose,
  name,
  approvalHistory,
  file,
  id,
  commentModel,
  setCommentModel,
  selectedRows,
  setSelectedRows,
  handleGet,
  docID,
  isDuplicate
}: ModalProps) {
  const [isCommentOpen, setIsCommentOpen] = useState<boolean>(false);
  const [fetchFileLoader, setFetchFileLoader] = useState(false);
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const { toastNotify, accountDetails, workFlowData, workflowProcess } = useContext(AppContext);
  const [isUploadOpen, setIsUploadOpen] = useState<boolean>(false);
  const [isViewerOpen, setIsViewerOpen] = useState<boolean>(false);
  const isBreakpoint = useBreakpointValue({ base: true, lg: false });

  const viewerWidth = useBreakpointValue({ lg: true });
  let width = "70vw";

  const [sample, setSample] = useState({
    url: "",
    file: null,
    type: null,
    buffer: null,
  });

  const handleOpenViewerModal = () => {
    setIsViewerOpen(true);
  };

  const handleCloseViewerModal = () => {
    setIsViewerOpen(false);
  };

  const handleOpenUploadModal = () => {
    setIsUploadOpen(true);
  };
  const handleCloseUploadModal = () => {
    setIsUploadOpen(false);
    onClose();
  };

  const handleCloseCommentModal = () => {
    setIsCommentOpen(false);
  };

  useEffect(() => {
    setSelectedFile(file);
    if (file) {
      setIsViewerOpen(true);
    }
  }, [isOpen, file]);

  useEffect(() => {
    if (isOpen) {
      getFile();
    }
  }, [isOpen, selectedFile]);

  const getFile = async () => {
    try {
      if (selectedFile) {
        setFetchFileLoader(true);
        const response: any = await appRequest("filesystem", "get", {
          id: selectedFile._id,
        });
        if (response) {
          if (response?.error) {
          } else {
            let buffer =
              typeof response === "string" ? JSON.parse(response) : response;
            buffer = new Uint8Array(buffer);

            const fileURL = URL.createObjectURL(
              new Blob([buffer], {
                type: selectedFile
                  ? selectedFile?.metadata?.contentType
                  : file?.metadata?.contentType,
              })
            );

            setSample({
              url: fileURL,
              file: file,
              type: selectedFile
                ? selectedFile?.metadata?.contentType
                : file?.metadata?.contentType,
              buffer: buffer,
            });
          }
        }
      }
    } catch (error: any) {
      toastNotify({
        title: "Error",
        message: error.message,
        type: "error",
      });
    } finally {
      setFetchFileLoader(false);
    }
  };

  const onCloseModal = () => {
    onClose();
  };

  console.log(workflowProcess?.processName)

  return (
    <>
      <Modal isOpen={isOpen} onClose={onCloseModal} size={"full"} isCentered>
        <ModalOverlay />
        <ModalContent
          position="fixed"
          right={isOpen ? "0" : `-${width}`}
          top="0"
          // height="100vh"
          width={viewerWidth ? width : "100vw"}
          animation={`${isOpen ? "slideIn" : "slideOut"
            } 0.8s ease-in-out forwards`}
        >
          <ModalHeader py={2} px={7}>
            <HeadingSS headingSS="Approval History" />
            <Text fontSize="md" color="gray" fontWeight="500">
              {docID}
            </Text>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Grid
              templateColumns={{
                md: "1fr",
                lg:
                  workFlowData?.fileViewer?.approvalModalOption ===
                    "pdfApproval" && !workFlowData?.fileViewer?.showApprHistory
                    ? "1fr"
                    : "1fr 20vw",
              }}
              gap="1rem"
            >
              {file && !isBreakpoint ? (
                fetchFileLoader ? (
                  <Box
                    h={{ base: "30vh", md: "40vh", lg: "74vh" }}
                    mb="1rem"
                    w="100%"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Spinner
                      size="xl"
                      thickness="4px"
                      speed="0.65s"
                      color="teal.400"
                    />
                  </Box>
                ) : (
                  <Box display={workflowProcess?.processName === "pr" || workflowProcess?.processName === "sr" ? "none" : "flex"} h={{ base: "30vh", md: "40vh", lg: "78vh" }} w="100%">
                    <FileViewer name={name} sample={sample} docId={docID} />
                  </Box>
                )
              ) : (
                <FileViewerModal
                  isOpen={isViewerOpen}
                  onClose={handleCloseViewerModal}
                  file={file}
                  documentId={docID}
                />
              )}
              {workFlowData?.fileViewer?.approvalModalOption ===
                "pdfApproval" ? (
                workFlowData?.fileViewer?.showApprHistory ? (
                  <ApprovalHistoryProgress
                    selectedFile={selectedFile}
                    initiatedBy={selectedRows?.length ? selectedRows?.length > 0 ? selectedRows[0].initiatedBy : null : null}
                    setSelectedFile={setSelectedFile}
                    approvalHistory={approvalHistory}
                    name={name}
                    id={id}
                    handleGet={handleGet}
                    onClose={onClose}
                    handleOpenViewer={handleOpenViewerModal}
                    isDuplicate={isDuplicate}
                  />
                ) : null
              ) : (
                <ApprovalHistoryProgress
                  selectedFile={selectedFile}
                  setSelectedFile={setSelectedFile}
                  approvalHistory={approvalHistory}
                  name={name}
                  initiatedBy={selectedRows?.length ? selectedRows?.length > 0 ? selectedRows[0].initiatedBy : null : null}
                  id={id}
                  handleGet={handleGet}
                  onClose={onClose}
                  handleOpenViewer={handleOpenViewerModal}
                  isDuplicate={isDuplicate}
                />
              )}
            </Grid>
          </ModalBody>

          <ModalFooter p="0.5rem">
            {" "}
            {name === "Pending Approval" &&
              accountDetails.role === "approver" &&
              accountDetails.role !== "admin" && (
                <Flex gap={4} display="none">
                  <Button
                    onClick={() => {
                      // handleDocUpdate('approved',documentId,level)
                      setCommentModel({
                        open: true,
                        selectedStatus: "approved",
                        comment: "",
                        isMulti: false,
                      });
                    }}
                    fontSize="sm"
                    bg="green.500"
                    color="white"
                    _hover={{ bg: "green.600" }}
                    w="100px"
                  >
                    Accept
                  </Button>
                  <Button
                    onClick={() =>
                      setCommentModel({
                        open: true,
                        selectedStatus: "rejected",
                        comment: "",
                        isMulti: false,
                      })
                    }
                    bg="red.500"
                    _hover={{ bg: "red.600" }}
                    color="white"
                    w="100px"
                  >
                    Reject
                  </Button>
                </Flex>
              )}
            {name === "Pending Approval" &&
              accountDetails.role === "uploader" && (
                <>
                  <Button
                    onClick={() => {
                      handleOpenUploadModal();
                    }}
                    fontSize="sm"
                    bg="teal.400"
                    color="white"
                    _hover={{ bg: "teal.500" }}
                    mt={2.5}
                  // mr="1rem"
                  // w="100px"
                  >
                    Reupload Document
                  </Button>
                </>
              )}
          </ModalFooter>
        </ModalContent>
        <style>
          {`
              @keyframes slideIn {
                from {
                  right: -${width};
                }
                to {
                  right: 0;
                }
              }

              @keyframes slideOut {
                from {
                  right: 0;
                }
                to {
                  right: -${width};
                }
              }

              `}
        </style>
        <CommentDrawer
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          handleGet={handleGet}
          view={true}
          isOpen={commentModel.open}
          width={width}
          onClose={handleCloseCommentModal}
          handleClose={onCloseModal}
          selectedFile={file}
        />
        <UploadDocumentModal
          isOpen={isUploadOpen}
          onClose={handleCloseUploadModal}
          type="reupload"
          id={id}
          handleGet={handleGet}
        />
      </Modal>
    </>
  );
}
